module.exports = __webpack_public_path__ + "static/img/plan_top_bg.75ab65d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/plan_top_bg.jpg
// module id = 8EwZ
// module chunks = 1